// src/api/StaticDataService.ts
import apiClient from "./ApiClient";
import { GuestTitle } from "../models/StaticDataModel";
import {
  normalizeCountriesLovMap,
  normalizeNationalitiesLovMap,
  normalizeTitlesLovMap,
} from "../utils/guestUtils";

function toCodeLabelMapFromArray(arr: any[]): Record<string, string> {
  return arr.reduce((acc: Record<string, string>, item: any) => {
    const [code, label] = Object.entries(item)[0] as [string, string];
    acc[code] = label;
    return acc;
  }, {});
}

export const fetchCountries = async (): Promise<Record<string, string>> => {
  const { data } = await apiClient.get("/countries");
  const raw = data?.countries ?? data ?? {};
  if (Array.isArray(raw)) return toCodeLabelMapFromArray(raw);
  return normalizeCountriesLovMap(raw as Record<string, string>);
};

export const fetchNationalities = async (): Promise<Record<string, string>> => {
  const { data } = await apiClient.get("/nationalities");
  const raw = data?.nationalities ?? data ?? {};
  if (Array.isArray(raw)) return toCodeLabelMapFromArray(raw);
  return normalizeNationalitiesLovMap(raw as Record<string, string>);
};

export const fetchTitles = async (): Promise<Record<string, string>> => {
  const { data } = await apiClient.get("/titles");
  const raw = data?.guestTitles ?? data ?? [];
  // OHIP-shape: array of { code, description } — `code` is the LOV value Opera expects on save.
  if (Array.isArray(raw)) {
    return (raw as GuestTitle[]).reduce((acc, t) => {
      const code = t.code?.trim();
      if (!code) return acc;
      acc[code] = t.description?.trim() || code;
      return acc;
    }, {} as Record<string, string>);
  }
  // OWS-shape: { camelCase(description) -> LOV value }. Re-key so the LOV value is canonical.
  return normalizeTitlesLovMap(raw as Record<string, string>);
};
